import { db } from '@core/db';
import { Project } from '@/types';

export interface CreateProjectInput {
  id: string;
  name: string;
  genreId: string;
  metadata: Project['metadata'];
  coverImage?: string;
}

export const projectsRepo = {
  async get(id: string) {
    return db.projects.get(id);
  },
  async list() {
    return db.projects.toArray();
  },
  async create(input: CreateProjectInput) {
    const now = new Date();
    const project: Project = { ...input, createdAt: now, updatedAt: now };
    await db.projects.put(project);
    return project;
  },
  async update(id: string, patch: Partial<Project>) {
    await db.projects.update(id, { ...patch, updatedAt: new Date() });
    return db.projects.get(id);
  },
  async remove(id: string) {
    await db.projects.delete(id);
  }
};
